/// <reference types="node" />

import { createHttpClient, createHttpInstance } from '@musinsa/packages-http';

/**
 * 무신사 스냅(liked-snaps, snaps/{id}/liked 등) API 전용 HTTP 클라이언트.
 *
 * base URL은 `NEXT_PUBLIC_MUSINSA_SNAP_API_BASE_URL` 환경변수로 지정합니다.
 * 예) dev: https://content.dev.musinsa.com
 *
 * `.musinsa.com` 쿠키 기반 인증을 위해 `withCredentials: true`를 사용하며,
 * 29CM(또는 무신사 로그인이 없는) 환경에서는 호출자 레벨에서
 * `service === SERVICE.MUSINSA` 가드로 호출을 차단합니다.
 */
const instance = createHttpInstance({
  baseURL: process.env.NEXT_PUBLIC_MUSINSA_SNAP_API_BASE_URL ?? '',
  withCredentials: true,
});

export const musinsaSnapClient = createHttpClient(instance);
